module.exports = __webpack_public_path__ + "static/media/09d.fe92b7d0.svg";